const defaultState = {
    layers: {
        1: { 
            name: 'Layer 1',
            columns: [],
            rows: [],
            values: [],
            showTotal: true
        } 
    },
    showModal: false,
    showTabs: true,
    showTotal: true,
    columns: [],
    rows: []
}

const reducers = (state = defaultState, { type, ...action }) => {
    switch(type){
        case 'layers':
            state = {...state, layers: {...state.layers, ...action.layers} }
            if(action.callback) action.callback()
            break
        case 'showModal':
            state = {...state, showModal: action.showModal}
            if(action.callback) action.callback()
            break
        case 'showTabs':
            state = {...state, showTabs: action.showTabs}
            if(action.callback) action.callback()
            break
        case 'showTotal':
            state = {...state, showTotal: action.showTotal}
            if(action.callback) action.callback()
            break
        case 'columns':
            state = {...state, columns: action.columns}
            if(action.callback) action.callback()
            break
        case 'rows':
            state = {...state, rows: action.rows}
            if(action.callback) action.callback()
            break
    } 
    return state
}

export default reducers